import { render, staticRenderFns } from "./TempServer.vue?vue&type=template&id=320e2e20&"
import script from "./TempServer.vue?vue&type=script&lang=js&"
export * from "./TempServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports